<template>
    <modal id="add-group-user-modal"
		title="Add user to one or more groups"
		:active="active"
		:dismissable="true"
		:max-width="1024"
		@dismiss="dismiss"
	>

        <modal-body>
            <form>
                <form-section label-width="100">

                    <control-group title="User">
                        <div v-control:static v-if="user">
                            <div>
                                {{user.firstName}} {{user.lastName}}
                                <tooltip :title="user.emailAddress" />
                            </div>
                        </div>
                        <div v-control:static v-else>
                            <span class="text-link" @click="previous">Choose a user</span>
                        </div>
                    </control-group>
                    <control-group title="Groups" :valid="!$v.selectedGroupRequests.$error">
                        <template v-if="$v.selectedGroupRequests.$error">
                            <control-error v-control:static v-if="!$v.selectedGroupRequests.required || !$v.selectedGroupRequests.minLength">
                                Choose at least one group you want {{user.firstName}} added to
                            </control-error>
                        </template>

                        <user-group-selector
                            :selectable="true"
                            :current-groups="groups"
                            @change="onSelectedGroupsChange"
                        />
                    </control-group>
                </form-section>
            </form>
        </modal-body>

        <modal-actions>
            <btn link @click="cancel" class="btn-left">Cancel</btn>

            <btn primary @click="addGroups">Add groups</btn>
		</modal-actions>
    </modal>
</template>

<script>
    import _ from 'lodash';
    import { required, minLength } from 'validators';
	import { notifications } from 'pdk/services';
    import { AsyncMixin, FormValidationMixin, ModalMixin } from 'pdk/mixins';
    import { users } from '@/services';
    import { UserGroupSelector } from '@/components/users';


	export default {
		name: 'add-group-user-modal',
		components: {
            UserGroupSelector
        },
        mixins: [AsyncMixin, FormValidationMixin, ModalMixin],
        props: {
            user: Object,
            groups: Array
        },
        data() {
            return {
                selectedGroups: undefined
            };
        },
        validations: {
            selectedGroupRequests: {
                required,
                minLength: minLength(1)
            }
        },
        computed: {
            selectedGroupRequests() {
                return _.map(this.selectedGroups, (g) => {
                    return {
                        globalUserID: this.user.globalUserID,
                        locationGroupID: g.locationGroupID,
                        role: g.role
                    };
                });
            }
        },
        methods: {
            addGroups(){
                if (!this.validate()) return;

                this.async(users.addUserToGroups({
                    globalUserID: this.user.globalUserID,
                    groups: this.selectedGroupRequests
                })).then(() => {
                    this.$emit('add', this.selectedGroupRequests);
                    notifications.open({
                        content: `Groups added`
                    });
                    this.close();
                })
                .catch(() => {
                    notifications.open({
                        content: 'Failed to add Group(s).'
                    });
                });
            },
            onSelectedGroupsChange(groups) {
                this.selectedGroups = groups;
            }
        }
    };
</script>